module.exports = __webpack_public_path__ + "img/8_no.dbf50237.svg";